<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div v-click-outside="closeModal" :class="mContainer">
          <div :class="mHeader">
            <slot name="header" />
          </div>

          <div :class="mBody" class="text-center">
            <slot name="body" />
          </div>

          <div :class="mFooter">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    mContainer: {
      type: String,
      required: false,
      default: "modal-container"
    },
    mHeader: {
      type: String,
      required: false,
      default: "modal-header"
    },
    mBody: {
      type: String,
      required: false,
      default: "modal-body"
    },
    mFooter: {
      type: String,
      required: false,
      default: "modal-footer"
    }
  },
  methods: {
    closeModal: function () {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss">
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
